export default function limitX(x: number) {
  return `?imageMogr2/thumbnail/${x}x`;
}
